import React from 'react';
import { Camera, MonitorUp } from 'lucide-react';

const ScreenCaptureControl = ({ isCaptureEnabled, setIsCaptureEnabled, selectWindow, screenshotPreview, questionNumber, setScreenshotPreview }) => {
    return (
        <div
            className="rounded-lg border p-4"
            style={{
                backgroundColor: 'var(--card-bg)',
                borderColor: 'var(--border-color)',
                boxShadow: 'var(--shadow-sm)',
            }}
        >
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div className="flex items-start gap-3">
                    <div
                        className="rounded-lg border p-2"
                        style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--alt-bg)', color: 'var(--primary-color)' }}
                    >
                        <Camera size={18} aria-hidden="true" />
                    </div>
                    <div>
                        <h4 className="text-lg font-semibold" style={{ color: 'var(--text-color)' }}>Screen capture</h4>
                        <p className="mt-1 text-sm" style={{ color: 'var(--muted-color)' }}>
                            Attach the current window as the prompt image for question {questionNumber}.
                        </p>
                    </div>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                    <label
                        className="flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-2"
                        style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--alt-bg)' }}
                    >
                    <input
                        type="checkbox"
                        checked={isCaptureEnabled}
                        onChange={(e) => {
                            setIsCaptureEnabled(e.target.checked);
                            if (!e.target.checked) {
                                setScreenshotPreview("");
                            }
                        }}
                        className="toggle-checkbox"
                    />
                    <span className="text-sm font-semibold" style={{ color: 'var(--text-color)' }}>Enable</span>
                </label>
                {isCaptureEnabled && (
                    <button
                        type="button"
                        className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-white transition-all duration-200"
                        style={{ backgroundColor: 'var(--primary-color)', boxShadow: 'var(--shadow-primary)' }}
                        onClick={selectWindow}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'var(--hover-color)')}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'var(--primary-color)')}
                    >
                        <MonitorUp size={16} aria-hidden="true" />
                        Select Window
                    </button>
                )}
                </div>
            </div>
            {screenshotPreview && (
                <div className="mt-4 rounded-lg border p-3" style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--alt-bg)' }}>
                    <h5 className="mb-2 text-sm font-semibold" style={{ color: 'var(--text-color)' }}>Screenshot preview</h5>
                    <img
                        src={screenshotPreview}
                        alt="Screenshot Preview"
                        className="max-h-72 w-full rounded-lg object-contain"
                        style={{ border: '1px solid var(--border-color)' }}
                    />
                </div>
            )}

        </div>
    );
};

export default ScreenCaptureControl;
